import { Button } from "./ui/button";
import { Brain } from "lucide-react";
import { useTaal } from "@/contexts/TaalContext";

/**
 * Something Novamund noticed about you, offered rather than stored.
 *
 * The whole point is that this card is the only way a statement about a person
 * gets written. It arrives with the answer and it leaves with it: nothing is
 * queued, nothing waits in a list of pending suggestions. Ignore it and it is
 * gone, which is what Frank chose over a stored proposal, and it costs one
 * repetition to get it back.
 *
 * Deliberately quiet. A card that shouts turns into something to dismiss
 * rather than something to read, and this one is asking permission.
 */
export default function MemoryProposal({ text, onRemember, onDismiss, busy }) {
  const { t } = useTaal();
  if (!text) return null;

  return (
    <div
      className="ml-12 max-w-prose rounded-lg border border-dashed p-3"
      data-testid="memory-proposal"
    >
      <div className="flex items-start gap-2">
        <Brain className="mt-0.5 h-4 w-4 shrink-0 text-muted-foreground" />
        <div className="min-w-0 flex-1">
          <p className="text-xs text-muted-foreground">{t("Dit over je onthouden?")}</p>
          <p className="mt-0.5 break-words text-sm">{text}</p>
          <div className="mt-2 flex flex-wrap gap-2">
            <Button
              size="sm"
              variant="outline"
              onClick={onRemember}
              disabled={busy}
              data-testid="memory-proposal-remember"
            >
              {t("Onthoud het")}
            </Button>
            <Button
              size="sm"
              variant="ghost"
              onClick={onDismiss}
              disabled={busy}
              data-testid="memory-proposal-dismiss"
            >
              {t("Nee, dank je")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
